import React from 'react';


const Header = ({ title }) => (
  <h3>
    <strong>
      {title}
    </strong>
  </h3>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx